import { NOT_LOGGED_IN_COUNT, TOTAL_ALL_STUDENTS_COUNT, TOTAL_STUDENT_LOGINS_COUNT } from "../../../../../routes/routeConstants/V2/apiRoutes";
import v2AxiosInstance from "../../../../../interceptor/v2AxiosInstance";

export default class V2DashboardService {
  static getTotalAllStudentsCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(TOTAL_ALL_STUDENTS_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

  static getLoginCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(TOTAL_STUDENT_LOGINS_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
  static getNotLoggedInCount(
    params: any,
    onSuccess: (data: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return v2AxiosInstance
      .get(NOT_LOGGED_IN_COUNT, { params })
      .then((response) => {
        onSuccess(response.data["count"]);
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }
}
